import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['container']
  static classes = ['tag']

  connect() {
    if (!this.hasContainerTarget) return

    for (const url of this.#trackingUrlsSet) {
      this.containerTarget.appendChild(this.#createTag(url))
    }
  }

  get #trackingUrlsSet() {
    const urls = Array.from(this.element.querySelectorAll('a[data-tracking-url]')).map(a => a.dataset.trackingUrl)

    return new Set(urls)
  }

  #createTag(url) {
    const tag = document.createElement('img')
    tag.src = url
    tag.alt = ''
    tag.classList.add(this.tagClass)

    return tag
  }
}
